import { AuxInlineMenu, AuxButton, AuxLink } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { handleInsInlineMenuItemClick } from "common/eventHandlers";
import { useBreakpoint } from "hooks/use-breakpoint";
export const InsResponsiveListButton = (props) => {
    const breakpoint = useBreakpoint();
    {
        if (breakpoint >= props.limitBreakpoint) {
            return React.createElement(React.Fragment, null, props.data.map((element, index) => {
                if (props.link) {
                    return React.createElement("div", { key: index },
                        React.createElement(AuxLink, { ...element }));
                }
                element.label = breakpoint >= props.limitBreakpoint - 1 ? element.label : "";
                element.size = element.size || AuxButtonSizeEnum.REGULAR;
                return React.createElement(AuxButton, { key: index, ...element });
            }));
        }
        const dataInlineMenu = [];
        props.data.forEach((element) => {
            dataInlineMenu.push([
                {
                    action: element.onClick,
                    label: element.label || "",
                    leftIcon: element.icon
                }
            ]);
        });
        return React.createElement(AuxInlineMenu, { data: dataInlineMenu, onInlineMenuItemClicked: handleInsInlineMenuItemClick },
            React.createElement(AuxButton, { className: "iconInlineMenu", slot: "target", icon: "widget-ellipsis", size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.TERTIARY }));
    }
};
